import { render, staticRenderFns } from "./PackProductButton.vue?vue&type=template&id=63abf6c2"
import script from "./PackProductButton.vue?vue&type=script&lang=js"
export * from "./PackProductButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports